export const getElementYOffset = ref => {
  const rect = ref.current.getBoundingClientRect()
  return window.pageYOffset + rect.y
}
